export default "__VITE_ASSET__9c118b48__"